export const customerType = [
  { value: 'business', label: 'Business' },
  { value: 'individual', label: 'Individual' },
];

export const gstTypesOptions = [
  { value: 'registered', label: 'Registered Business - Regular' },
  { value: 'unregistered', label: 'Unregistered Business' },
];

export const gstTreatmentOptions = [
  {
    value: 'taxable',
    label: 'Taxable',
  },
  { value: 'non-taxable', label: 'Tax Exempt' },
];

export const getCustomerTypeLabel = (value: string) => {
  return customerType.find((opt) => opt.value === value)?.label || value;
};

export const getGstTypeLabel = (value: string) => {
  return gstTypesOptions.find((opt) => opt.value === value)?.label || value;
};

export const getGstTreatmentLabel = (value: string) => {
  return gstTreatmentOptions.find((opt) => opt.value === value)?.label || value;
};
